import * as React from 'react';
import { WithRouterProps } from 'react-router';

import BoxBody from 'components/BoxBody';
import Columns2 from 'components/Columns2';
// @ts-ignore
import { ConfirmableDeviceType } from 'entities/Device';
import DialogContent from 'components/DialogContent';
import JoinSignUpForm from './JoinSignUpForm';
import JoinConfirmDevicePage from './JoinConfirmDevicePage';
import TitleHeader from 'components/TitleHeader';

import './styles/JoinSignUpPage.scss';

type Props = WithRouterProps;
type Status = 'initial_form' | 'device_confirmation';
type State = {
  deviceUid?: string;
  fullName?: string;
  status: Status;
  deviceType?: ConfirmableDeviceType;
};

class JoinSignUpPage extends React.Component<Props, State> {
  state: State = {
    status: 'initial_form',
  };

  onUserCreate = () => {
    this.props.router.push('/landing');
  };

  handleUidSubmit = (deviceUid: string, deviceType: string, fullName: string) => {
    this.setState({ deviceUid, deviceType, fullName, status: 'device_confirmation' });
  };

  resetState = () => {
    this.setState({
      status: 'initial_form',
      deviceUid: undefined,
      fullName: undefined,
      deviceType: undefined,
    });
  };

  renderInitialForm = () => {
    const title = 'Sign up for Remind';

    return (
      <DialogContent size="large">
        <BoxBody>
          <Columns2 flex reset="tablet" resetFlush>
            <div className="JoinSignUpPage-sidebar">
              <TitleHeader
                image={require('assets/images/signup-devices.svg')}
                title={title}
                subtext="Reach students and parents where they are. Send quick, simple messages
                  to any device—for free."
              />
            </div>
            <div>
              <TitleHeader title={title} className="JoinSignUpPage-title" />
              <JoinSignUpForm
                data-test-selector="name-and-device-form"
                onUidSubmit={this.handleUidSubmit}
                onGoogleSignIn={this.onUserCreate}
              />
            </div>
          </Columns2>
        </BoxBody>
      </DialogContent>
    );
  };

  renderConfirmationFlow = () => {
    const { deviceType, deviceUid, fullName } = this.state;
    if (!!deviceType && !!deviceUid && !!fullName) {
      return (
        <JoinConfirmDevicePage
          deviceType={deviceType}
          fullName={fullName}
          deviceUid={deviceUid}
          onDone={this.onUserCreate}
          onUserUpdateFailure={this.resetState}
        />
      );
    } else {
      return null;
    }
  };

  render() {
    switch (this.state.status) {
      case 'initial_form':
        return this.renderInitialForm();
      case 'device_confirmation':
        return this.renderConfirmationFlow();
      default:
        return null;
    }
  }
}

export { JoinSignUpPage };
export default JoinSignUpPage;
